import { Action, createReducer, on } from '@ngrx/store';

import * as fromAction from './classroom-course.action';
import { classroomCourseAdapter } from './classroom-course.entity';
import { ClassroomCourseState } from './classroom-course.state';
import { ClassroomCourseFilter } from '../models';

const initialState: ClassroomCourseState = classroomCourseAdapter.getInitialState({
  selectedCourseId: null,
  schedules: [],
  instructorCourses: [],
  error: null,
  totalCount: 0,
  filter: new ClassroomCourseFilter(),
  participantIdentity: null
});

const _classroomCourseReducer = createReducer(
  initialState,
  on(fromAction.AddClassroomCourses, (state, { courses }) => {
    return classroomCourseAdapter.setAll(courses, state);
  }),
  on(fromAction.AddClassroomCourse, (state, { course }) => {
    return classroomCourseAdapter.upsertOne(course, state);
  }),
  on(fromAction.AddClassroomSchedule, (state, { schedules }) => {
    return classroomCourseAdapter.addMany([], { ...state, schedules });
  }),
  on(fromAction.RemoveClassroomSchedule, (state) => {
    return classroomCourseAdapter.addMany([], { ...state, schedules: [] });
  }),
  on(fromAction.AddInstructorCourses, (state, { instructorCourses }) => {
    return classroomCourseAdapter.addMany([], { ...state, instructorCourses });
  }),
  on(fromAction.AddSelectedCourse, (state, { selectedCourseId }) => {
    return classroomCourseAdapter.addMany([], { ...state, selectedCourseId });
  }),
  on(fromAction.RemoveSelectedClassroomCourse, (state) => {
    return classroomCourseAdapter.addMany([], { ...state, selectedDigitalCourseId: null });
  }),
  on(fromAction.AddParticipantIdentity, (state, { participant }) => {
    return classroomCourseAdapter.addMany([], {...state, participantIdentity: participant })
  }),
  on(fromAction.RemoveParticipantIdentity, (state) => {
    return classroomCourseAdapter.addMany([], {...state, participantIdentity: null })
  }),
  on(fromAction.AddTotalCount, (state, { totalCount }) => {
    return classroomCourseAdapter.addMany([], { ...state, totalCount: totalCount });
  }),
  on(fromAction.AddError, (state, { error }) => {
    return classroomCourseAdapter.addMany([], { ...state, error: error });
  })
);

export function classroomCourseReducer(
  state: ClassroomCourseState = initialState,
  action: Action
): ClassroomCourseState {
  return _classroomCourseReducer(state, action);
}
